module.exports = __webpack_public_path__ + "static/saint-68754e856653ce2e964cb8685a6a606f.jpg";